import * as sonbpIfconst from "../sonbpIf/base/constants";
import * as es6promise from "es6-promise";
import * as idbEdit from "../entity/idb/editInfo";
import { constDialogMessage, dialogUtil } from "../util";
import { Logger } from "../util/logger";
import { cmnPart, GetEditInfo } from "../entity";
import { util } from "..";

import * as edconst from "./edit.const";
import * as edentity from "./edit.entity";
import * as edtool from "./edit.tool";


//------------------------------------------------------------------------------
// sonbpIfラッパー
//------------------------------------------------------------------------------

//import * as SonbpIf from "SonbpIf";
//import * as sonbp from "sonbp";
declare var SonbpIf: any;
declare var sonbp: any;


/**
 * sonbpIFの担当クラス
 */
export class sonbpIFContoroller {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------
    /**
     * sonbpのcanvasを配置するdiv要素のid属性値
     */
    private readonly CANVAS_DIV_ID: string = "box_view";

    /**
     * アイテム移動のデフォルト移動量
     */
    private readonly MOVE_ITEM_AMOUNT_DEFAULT: number = 1;

    /**
     * 画像未設定の画像枠のfile_id
     */
    public readonly EMPTY_PHOTOBOX_FILE_ID: string = "@DUMMY@";

    /**
     * あいさつ文生成のモード(初期配置)
     */
    public readonly GREETING_SET_MODE_NEW: string = "1";
    /**
     * あいさつ文生成のモード(既存変更)
     */
    public readonly GREETING_SET_MODE_UPD: string = "2";

    /*
     * sonbpプレフィックス
     */
    private readonly SONBP_URI_PREFIX: string = "ffpsc/";

    /*
     * ポスカ仮想ディレクトリ
     */
    private readonly POSCA_VIRTUAL_DIR: string = "";

    /*
     * Sonbpクライアント種別(PC)
     */
    private readonly SONBP_CLIENT_PC: string = "PC";

    /*
     * Sonbpクライアント種別(SP)
     */
    private readonly SONBP_CLIENT_SP: string = "SP";


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------
    /**
     * Vue.jsオブジェクト
     */
    protected vue: Vue;

    /**
     * sonbpIFオブジェクト
     */
    private sonbpIf: any;

    /**
     * 画像枠使用可否フラグ
     */
    private enablePhotobox: boolean;

    /**
     * 差出人使用可否フラグ
     */
    private enableSender: boolean;

    /**
     * 編集モード
     */
    private editMode: edconst.editModeKind;

    /**
      * 一時編集ID(暗号化)
      */
    public tempId: string;

    /**
    * 編集開始日(暗号化)
    */
    public encCreateDate: string;

    /**
     * 認証トークン 
     */
    private authToken: string;

    /**
     * テンプレートPDFのページサイズ(幅)
     */
    private pdfPageSizeWidth: number;

    /**
     * テンプレートPDFのページサイズ(高さ)
     */
    private pdfPageSizeHeight: number;

    /**
     * あいさつ文の一覧
     */
    private greetingList: edentity.greetingTranEntityEx[];

    /**
     * あいさつ文のデザイン定義
     */
    private greetingDesign: GetEditInfo.DesignDetailEntity;

    /**
     * 差出人のデザイン定義
     */
    private senderDesign: GetEditInfo.DesignDetailEntity;

    /**
     * 差出人情報
     */
    private senderInfo: edentity.senderTranEntityEx;

    /**
     * オブジェクト配置有効領域
     */
    private putRange: cmnPart.putRange;

    /**
     * オブジェクト配置有効領域
     */
    private putRangeStamp: cmnPart.putRangeStamp;

    /**
     * 画像枠一覧
     */
    private photoFrameList: edentity.photoFrame[];

    /**
     * デフォルト文字色
     */
    private defaultFontColor: GetEditInfo.GetEditInfoColorEntity;

    /**
     * 色定義マスタの一覧
     */
    private colorMasterList: GetEditInfo.GetEditInfoColorEntity[];

    /**
     * テンプレートに画像枠が存在するか
     */
    private existsPhotoBox: boolean;

    /**
     * PCサイト？
     */
    private usePcDesign: boolean;

    /**
     * デザインマスタ
     */
    private designMaster: GetEditInfo.GetEditInfoDesignEntity;


    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------
    /**
     * Vueオブジェクト
     */
    public set Vue(vue: Vue) {
        this.vue = vue;
    }

    /**
     * 認証トークン
     */
    public set AuthToken(authToken: string) {
        this.authToken = authToken;
    }

    /**
     * sonbpIFオブジェクト
     */
    public get SonbpIf(): any {
        return this.sonbpIf;
    }

    /**
     * 画像枠使用可否フラグ
     */
    public get EnablePhotobox(): boolean {
        return this.enablePhotobox;
    }

    /**
     * 差出人使用可否フラグ
     */
    public get EnableSender(): boolean {
        return this.enableSender;
    }

    /**
     * 編集モード
     */
    public get EditMode(): edconst.editModeKind {
        return this.editMode;
    }

    /**
     * テンプレートPDFのページサイズ(幅)
     */
    public get PdfPageSizeWidth(): number {
        return this.pdfPageSizeWidth;
    }

    /**
     * テンプレートPDFのページサイズ(高さ)
     */
    public get PdfPageSizeHeight(): number {
        return this.pdfPageSizeHeight;
    }

    /**
     * あいさつ文の一覧
     */
    public get GreetingList(): edentity.greetingTranEntityEx[] {
        return this.greetingList;
    }

    /**
     * あいさつ文のデザイン定義
     */
    public set GreetingDesign(greetingDesign: GetEditInfo.DesignDetailEntity) {
        this.greetingDesign = greetingDesign;
    }

    /**
     * 差出人のデザイン定義
     */
    public set SenderDesign(senderDesign: GetEditInfo.DesignDetailEntity) {
        this.senderDesign = senderDesign;
    }

    /**
     * 差出人情報
     */
    public get SenderInfo(): edentity.senderTranEntityEx {
        return this.senderInfo;
    }
    public set SenderInfo(sender: edentity.senderTranEntityEx) {
        this.senderInfo = sender;
    }

    /**
     * オブジェクト配置有効領域
     */
    public set PutRange(putRange: cmnPart.putRange) {
        this.putRange = putRange;
    }

    /**
     * オブジェクト配置有効領域（スタンプ）
     */
    public set PutRangeStamp(putRangeStamp: cmnPart.putRangeStamp) {
        this.putRangeStamp = putRangeStamp
    }

    /**
     * 画像枠一覧
     */
    public get PhotoFrameList(): edentity.photoFrame[] {
        return this.photoFrameList;
    }

    /**
     * デフォルト文字色
     */
    public set DefaultFontColor(colorMaster: GetEditInfo.GetEditInfoColorEntity) {
        this.defaultFontColor = colorMaster;
    }

    /**
     * 色定義マスタの一覧
     */
    public set ColorMasterList(colorMasterList: GetEditInfo.GetEditInfoColorEntity[]) {
        this.colorMasterList = colorMasterList;
    }

    /**
     * テンプレートに画像枠が存在するか
     */
    public get ExistsPhotoBox(): boolean {
        return this.existsPhotoBox;
    }

    /**
     * デザインマスタ
     */
    public set DesignMaster(designMaster: GetEditInfo.GetEditInfoDesignEntity) {
        this.designMaster = designMaster;
    }


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    /**
     * コンストラクタ
     */
    constructor(usePcDesign: boolean) {

        //SonbpIfClassは画面シングルトンで利用
        this.sonbpIf = new SonbpIf.SonbpIfClass();

        this.enablePhotobox = false;
        this.enableSender = false;
        this.editMode = edconst.EDIT_MODE_KIND.SET_PHOTO;
        this.greetingList = [];
        this.photoFrameList = [];
        this.existsPhotoBox = true;

        this.usePcDesign = usePcDesign;
    }

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    /**
     * アイテム選択通知の初期処理
     * @summary アイテム選択でモード切替を行うため（2025年対応：配置済み画像の再編集可能 #28295）
     */
    private _onChangeInit(editMode: edconst.editModeKind, vps: itemVenderProperty): void { };
    /**
     * アイテム選択通知の初期処理セット
     */
    public setOnChangeInitFunc(callback: (editMode: edconst.editModeKind, vps: itemVenderProperty) => void) {

        this._onChangeInit = callback;
    };

    /**
     * sonbp起動 
     */
    public start(pageAreaOffset: cmnPart.AreaCoordinate): es6promise.Promise<any> {

        return new Promise((resolve, reject) => {

            let result: boolean = false;
            const that = this;

            // オプションの指定
            this.sonbpIf.setOption({
                put_range: {
                    w: this.putRange.w,
                    h: this.putRange.h,
                },
                put_range_stamp: {
                    w: this.putRangeStamp.w,
                    h: this.putRangeStamp.h,
                },
                page_offset: {
                    x: pageAreaOffset.x,
                    y: pageAreaOffset.y
                }
            });

            const sonbpClient: string = this.usePcDesign ? this.SONBP_CLIENT_PC : this.SONBP_CLIENT_SP;

            // sonbp初期化
            this.sonbpIf.sonbpInit(this.vue, this.CANVAS_DIV_ID, this.SONBP_URI_PREFIX, this.POSCA_VIRTUAL_DIR, sonbpClient, this.authToken, function (res: any) {
                // 結果判定
                if (res.code === 0) {

                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
                    // アイテム選択通知メソッド登録
                    that.sonbpIf.onChangeSelectItem((vps: itemVenderProperty) => {

                        Logger.debug("選択アイテム更新 item[" + JSON.stringify(vps) + "]");

                        // 違うタイプの場合モード切替
                        that._onChangeInit(that.editMode, vps);

                        if (that.usePcDesign) {
                            // PCの場合

                            if (vps === null) {
                                // 選択解除の場合
                                if (that.editMode === edconst.EDIT_MODE_KIND.MANI_PHOTO) {
                                    that.vue.$data.Show.OparatePalletCover = true;
                                    that.vue.$data.EnablePhotoCorrect = false;
                                    that.vue.$data.EnablePitaCorrect = false;
                                    that.vue.$data.PhotoCorrectCaption = edconst.EditConst.PHOTO_CORRECT_CAPTION_PC_OFF
                                    that.vue.$data.Show.IsImageAutoFilter = true; // 補正あり
                                    that.vue.$data.Show.IsImagePita = false; // 枠ぴったりＯＦＦ
                                    that.vue.$data.isBrightDownDisabled = false;
                                    that.vue.$data.isBrightUpDisabled = false;
                                    that.vue.$data.Show.OparatePalletBrightCover = false;
                                }
                                return;
                            }

                            // 処理モード判定
                            if (that.editMode === edconst.EDIT_MODE_KIND.SET_PHOTO) {
                                // 画像読込・配置の場合

                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.MANI_PHOTO) {
                                // 画像操作の場合
                                // オブジェクト操作パレットの活性制御
                                if (util.verify.isNotEmpty(vps)) {
                                    that.vue.$data.Show.OparatePalletCover = (vps.file_id == that.EMPTY_PHOTOBOX_FILE_ID) ? true : false;
                                    // 画像補正しないパレットの活性制御
                                    that.vue.$data.EnablePhotoCorrect = (vps.file_id != that.EMPTY_PHOTOBOX_FILE_ID) ? true : false;
                                    that.vue.$data.EnablePitaCorrect = (vps.file_id != that.EMPTY_PHOTOBOX_FILE_ID) ? true : false;
                                    // 対象画像枠情報取得
                                    const targetFrame: edentity.photoFrame = util.relic.listFind(that.photoFrameList, (pf: edentity.photoFrame) => {
                                        return pf.idx === vps.idx;
                                    });
                                    that.vue.$data.PhotoCorrectCaption = targetFrame.useI2 ? edconst.EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : edconst.EditConst.PHOTO_CORRECT_CAPTION_PC_ON;
                                    that.vue.$data.Show.IsImageAutoFilter = targetFrame.useI2;
                                    that.vue.$data.Show.IsImagePita = vps.waku_pita ?? false;

                                    if (vps.file_id === "@DUMMY@") {
                                        that.vue.$data.PhotoBright = 0
                                    } else {
                                        let fileIdSplit = vps.file_id.split('@');
                                        if (fileIdSplit.length < 2) {
                                            that.vue.$data.PhotoBright = 0
                                        } else {
                                            that.vue.$data.PhotoBright = fileIdSplit[1];
                                        }
                                    }

                                    if (targetFrame.useI2) {
                                        if (that.vue.$data.PhotoBright > 9) {
                                            that.vue.$data.isBrightUpDisabled = true;
                                        } else {
                                            that.vue.$data.isBrightUpDisabled = false;
                                        }
                                        if (that.vue.$data.PhotoBright < -9) {
                                            that.vue.$data.isBrightDownDisabled = true;
                                        } else {
                                            that.vue.$data.isBrightDownDisabled = false;
                                        }
                                        that.vue.$data.Show.OparatePalletBrightCover = false;
                                    } else {
                                        that.vue.$data.isBrightDownDisabled = true;
                                        that.vue.$data.isBrightUpDisabled = true;
                                        that.vue.$data.Show.OparatePalletBrightCover = true;
                                    }
                                }
                                else {
                                    that.vue.$data.Show.OparatePalletCover = true;
                                    // 画像補正しないパレットの活性制御
                                    that.vue.$data.EnablePhotoCorrect = false;
                                    that.vue.$data.EnablePitaCorrect = false;
                                    that.vue.$data.PhotoCorrectCaption = edconst.EditConst.PHOTO_CORRECT_CAPTION_PC_OFF
                                    that.vue.$data.Show.IsImageAutoFilter = true; // 補正あり
                                    that.vue.$data.Show.IsImagePita = false; // 枠ぴったりＯＦＦ
                                    that.vue.$data.isBrightDownDisabled = false;
                                    that.vue.$data.isBrightUpDisabled = false;
                                    that.vue.$data.Show.OparatePalletBrightCover = false;
                                }
                                
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.GREETING) {
                                // あいさつ文操作モード
                                Logger.debug("アイテム選択通知 [", vps);
                                Logger.debug("作成済みアイテム [", that.greetingList);

                                if (!that.vue.$data.EnableOnChangeForGreeting) {
                                    Logger.debug("あいさつ文作成中なのでスキップ");
                                    return;
                                }

                                // PC・SP共通処理
                                that.onChangeGreetingSelectItem(vps);

                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Top = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Bottom = false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.SENDER) {
                                // 差出人操作モード の場合
                                if (!that.vue.$data.EnableOnChangeForSender) {
                                    Logger.debug("差出人作成中なのでスキップ");
                                    return;
                                }
                                that.setSenderOrder(that, that.senderInfo);
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Top = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Bottom = false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.STAMP) {
                                // スタンプ操作モード の場合
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Top = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Bottom = false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.MYSTAMP) {
                                // Myステッカー操作モード の場合
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Top = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Bottom = false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.FONTGENIC) {
                                // 手書きスタンプ操作モード の場合
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Top = (vps === null) ? true : false;
                                that.vue.$data.Show.OparatePalletCover4Bottom = false;

                                // 色番号アクティブ化
                                if (vps === null) {
                                    that.vue.$data.SelectTegakiColor = "";
                                } else {
                                    let idParts = vps.file_id.split('@');
                                    let colorNo = idParts[1];
                                    that.vue.$data.SelectTegakiColor = colorNo;
                                }
                            }
                        }
                        else {
                            // SPの場合

                            // 処理モード判定
                            if (that.editMode === edconst.EDIT_MODE_KIND.SET_PHOTO) {
                                // 画像読込・配置の場合

                                if (!that.vue.$data.Show.SwapItemMenu || !that.vue.$data.SwatpItem.doSwap) {
                                    Logger.debug("画像読込・配置モード(通常)");
                                    if (vps === null) {
                                        // 選択解除の場合

                                        //画像選択時の操作メニュー非表示
                                        that.vue.$data.Show.EditImageMenu = false;
                                        // ツールメニュー表示
                                        that.vue.$data.Show.SetPhotoMenu = true;
                                    }
                                    else {
                                        // 選択の場合
                                        if (vps.file_id === that.EMPTY_PHOTOBOX_FILE_ID) {
                                            // 画像枠に写真なしの場合

                                            // 画像一覧表示へ
                                            // 編集エリア非表示
                                            that.vue.$data.Show.EditArea = false;
                                            // 画像一覧を表示
                                            that.vue.$data.Header.Title = edconst.EditConst.TITLE_IMAGELIST;
                                            that.vue.$data.Show.FooterMenu = false;
                                            {
                                                that.vue.$data.Show.ReturnFlowBtn = false;
                                                that.vue.$data.Show.ReturnHomeBtn = true;
                                                that.vue.$data.Show.ReturnHomeExBtn = false;
                                                that.vue.$data.Show.NextFlowBtn = false;
                                                that.vue.$data.Show.NextHomeFromImgListBtn = true;
                                                that.vue.$data.Show.NextHomeFromMyStampListBtn = false;
                                                that.vue.$data.Show.NextHomeFromTegakiStampListBtn = false;
                                                that.vue.$data.Show.PhotoDeleteBtn = true;
                                                that.vue.$data.Show.MySTampDeleteBtn = false;
                                                that.vue.$data.Show.TegakiStampListTrashBtn = false;
                                                that.vue.$data.EnableUploadListTrashOK = false;

                                            }
                                            // ツールメニュー非表示
                                            that.vue.$data.Show.FooterMenu = false;
                                            that.vue.$data.Show.PhotoList = true;
                                        }
                                        else {
                                            // 画像枠に写真ありの場合
                                            // ツールメニュー非表示
                                            that.vue.$data.Show.SetPhotoMenu = false;
                                            // 画像選択時の操作メニュー表示
                                            that.vue.$data.Show.EditImageMenu = true;
                                            // 対象画像枠情報取得
                                            const targetFrame: edentity.photoFrame = util.relic.listFind(that.photoFrameList, (pf: edentity.photoFrame) => {
                                                return pf.idx === vps.idx;
                                            });
                                            // I2補正のキャプションを復元する。
                                            that.vue.$data.PhotoCorrectCaption = targetFrame.useI2 ? edconst.EditConst.PHOTO_CORRECT_CAPTION_SP_OFF : edconst.EditConst.PHOTO_CORRECT_CAPTION_SP_ON;
                                            that.vue.$data.Show.IsImageAutoFilter = targetFrame.useI2;
                                            // 枠ぴったり区分取得
                                            that.vue.$data.Show.IsImagePita = vps.waku_pita ?? false;

                                            // 明るさ調整
                                            that.vue.$data.Show.OparatePalletBrightCover = targetFrame.useI2 ? false : true;
                                            if (vps.file_id === "@DUMMY@") {
                                                that.vue.$data.PhotoBright = 0;
                                            } else {
                                                let fileIdSplit = vps.file_id.split('@');
                                                if (fileIdSplit.length < 2) {
                                                    that.vue.$data.PhotoBright = 0;
                                                } else {
                                                    that.vue.$data.PhotoBright = fileIdSplit[1];
                                                }
                                            }
                                        }

                                    }
                                }
                                else {
                                    Logger.debug("画像読込・配置モード(入替)");

                                    if (vps !== null) {
                                        // 選択の場合
                                        if (util.verify.isNotLengthZero(that.vue.$data.SwatpItem.FromItem)) {
                                            // 2つ目の指定
                                            that.vue.$data.SwatpItem.ToItem = vps.idx;

                                            that.sonbpIf.mutualTradePhoto(that.vue.$data.SwatpItem.FromItem, that.vue.$data.SwatpItem.ToItem, (res: any) => {
                                                if (res.code === 0) {
                                                    // 正常終了
                                                }
                                                else {
                                                    // 異常終了
                                                    Logger.error("入替操作 失敗 [" + JSON.stringify(res) + "]");
                                                    dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_SWAP_PHOTO, dialogUtil.closeErrorDialog);
                                                }
                                            });
                                        }
                                    }

                                    // どちらでも、入替モード終了
                                    that.vue.$data.SwatpItem.FromItem = "";
                                    that.vue.$data.SwatpItem.ToItem = "";
                                    that.vue.$data.Show.MessageArea = false;
                                    that.vue.$data.Show.EditImageMenu = false;
                                    that.vue.$data.Show.SetPhotoMenu = true;
                                    that.vue.$data.Show.ReturnFlowBtn = true;
                                    that.vue.$data.Show.ReturnHomeFromSwapItemBtn = false;
                                    that.vue.$data.Header.Title = edconst.EditConst.TITLE_MAIN;
                                    that.vue.$data.SwatpItem.doSwap = false;

                                }
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.MANI_PHOTO) {
                                // 画像操作の場合
                                Logger.debug(" 画像操作モード");

                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.GREETING) {
                                // あいさつ文操作モード
                                Logger.debug("あいさつ文操作モード");

                                Logger.debug("アイテム選択通知 [", vps);
                                Logger.debug("作成済みアイテム [", that.greetingList);

                                if (!that.vue.$data.EnableOnChangeForGreeting) {
                                    Logger.debug("あいさつ文作成中なのでスキップ");
                                    return;
                                }

                                // PC・SP共通処理
                                that.onChangeGreetingSelectItem(vps);
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.SENDER) {
                                // 差出人操作モード の場合
                                Logger.debug("差出人操作モード");

                                if (!that.vue.$data.EnableOnChangeForSender) {
                                    Logger.debug("差出人作成中なのでスキップ");
                                    return;
                                }
                                that.setSenderOrder(that, that.senderInfo);
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.STAMP) {
                                // スタンプ操作モード の場合
                                Logger.debug("スタンプ操作モード");
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;
                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.MYSTAMP) {
                                // Myステッカー操作モード の場合
                                Logger.debug("Myステッカー操作モード");
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;

                            }
                            else if (that.editMode === edconst.EDIT_MODE_KIND.FONTGENIC) {
                                // 手書きスタンプ操作モード の場合
                                that.vue.$data.Show.OparatePalletCover = (vps === null) ? true : false;

                                // 色番号アクティブ化
                                if (vps === null) {
                                    that.vue.$data.SelectTegakiColor = "";
                                } else {
                                    let idParts = vps.file_id.split('@');
                                    let colorNo = idParts[1];
                                    that.vue.$data.SelectTegakiColor = colorNo;
                                }
                            }
                        }
                    });
                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/

                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
                    //２つの画像枠で画像交換通知
                    that.sonbpIf.onExhangePhtoItem((a: { waku: itemVenderProperty, img: itemVenderProperty }, b: { waku: itemVenderProperty, img: itemVenderProperty }) => {
                        Logger.debug("２つの画像枠で画像交換 a,b->", a, b);

                        const pfA: edentity.photoFrame = util.relic.listFind(that.PhotoFrameList, (pf: edentity.photoFrame) => {
                            return pf.idx === a.waku.idx;
                        });
                        const pfB: edentity.photoFrame = util.relic.listFind(that.PhotoFrameList, (pf: edentity.photoFrame) => {
                            return pf.idx === b.waku.idx;
                        });

                        let fileId_ = pfA.fileId;
                        let useI2_ = pfA.useI2;
                        let brightId_ = pfA.brightId;

                        pfA.fileId = pfB.fileId;
                        pfA.useI2 = pfB.useI2;
                        pfA.brightId = pfB.brightId;
                        pfB.fileId = fileId_;
                        pfB.useI2 = useI2_;
                        pfB.brightId = brightId_;

                        console.debug("exchange after.", {
                            a: { pf: pfA, vp: a },
                            b: { pf: pfB, vp: b }
                        });
                    });
                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/

                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
                    // セッションエラー通知ハンドリング
                    that.sonbpIf.onApiError((e: any) => {
                        // responseCode = httpcode
                        if (e.responseCode === 401) {
                            util.ajax.TransErrorPage();
                            return false;
                        }
                        return true;
                    });
                    //_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/

                    // sonbp起動
                    that.sonbpIf.sonbpStart(function (res: any) {
                        // 結果判定
                        if (res.code === 0) {

                            // PDFのページサイズ取得
                            const pageSize = that.sonbpIf.getPageSize();
                            that.pdfPageSizeWidth = pageSize.w;
                            that.pdfPageSizeHeight = pageSize.h;

                            // テンプレート種別判定
                            // ①差出人レイヤーの初期配置座標プロパティ(def_posi)が存在するかを判定
                            var layers = that.sonbpIf.getLayers();
                            for (let i: number = 0; i < layers.length; i++) {
                                if (layers[i].layer_type === "SENDER_LAYER") {
                                    if (layers[i].def_posi !== undefined && that.senderDesign) {
                                        // 初期配置座標プロパティあり
                                        that.enableSender = true;
                                    }
                                }
                            }

                            // ②画像レイヤーに画像枠が存在するかを判定
                            //const itemType: string[] = [sonbpIfconst.ITYPE_PHOTO_BOX];
                            const itemType: string[] = [];
                            that.sonbpIf.getItems(itemType, (res: any, list: itemVenderProperty[]) => {
                                // 結果判定
                                if (res.code === 0) {

                                    Logger.debug("getItems [" + JSON.stringify(list) + "]");
                                    let selectItem: itemVenderProperty = null;

                                    // 画像枠の存在チェック
                                    const firstPhotoBox = getFirstItem(list, sonbpIfconst.ITYPE_PHOTO_BOX);


                                    // 設定可能な処理モード確定
                                    if (firstPhotoBox !== undefined) {
                                        that.existsPhotoBox = true;
                                        // 画像読込・配置モード
                                        that.enablePhotobox = true;
                                        that.editMode = edconst.EDIT_MODE_KIND.SET_PHOTO;
                                        selectItem = firstPhotoBox;

                                        // 画像枠一覧初期化
                                        for (let i: number = 0; i < list.length; i++) {
                                            if (list[i].item_type === sonbpIfconst.ITYPE_PHOTO_BOX) {
                                                let selPhotoFrame: edentity.photoFrame = util.relic.listFind(that.photoFrameList, (ph: edentity.photoFrame) => {
                                                    return ph.idx === list[i].idx;
                                                });
                                                if (selPhotoFrame === undefined) {
                                                    selPhotoFrame = new edentity.photoFrame();
                                                    selPhotoFrame.idx = list[i].idx;
                                                    that.photoFrameList.push(selPhotoFrame);
                                                }

                                                // 枠情報復元
                                                if (list[i].file_id === that.EMPTY_PHOTOBOX_FILE_ID) {
                                                    //画像配置なし
                                                    selPhotoFrame.fileId = "";
                                                    selPhotoFrame.useI2 = true;
                                                    selPhotoFrame.brightId = 0;
                                                } else if (list[i].file_id.indexOf('@') >= 0) {
                                                    //画像配置あり（I2補正ON）
                                                    let idParts = list[i].file_id.split('@');
                                                    selPhotoFrame.fileId = idParts[0];
                                                    selPhotoFrame.useI2 = true;
                                                    selPhotoFrame.brightId = Number(idParts[1]);
                                                } else {
                                                    //画像配置あり（I2補正OFF）
                                                    selPhotoFrame.fileId = list[i].file_id;
                                                    selPhotoFrame.useI2 = false;
                                                    selPhotoFrame.brightId = 999;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        that.existsPhotoBox = false;

                                        if (that.designMaster.printType === edconst.EditConst.PRINT_TYPE_BOTH) {
                                            // 銀塩・印刷両方
                                            // →仕上がり選択だけできる、特殊な画像読込・配置モードを設定
                                            that.editMode = edconst.EDIT_MODE_KIND.SET_PHOTO;
                                            selectItem = null;
                                        }
                                        else if (that.enableSender && that.senderDesign) {
                                            // 差出人操作モード
                                            that.editMode = edconst.EDIT_MODE_KIND.SENDER;

                                            const firstSender = getFirstItem(list, sonbpIfconst.ITYPE_SENDER_TXT);
                                            if (firstSender !== undefined) {
                                                selectItem = firstSender;
                                            }
                                        }
                                        else {
                                            // あいさつ文操作モード
                                            that.editMode = edconst.EDIT_MODE_KIND.GREETING;

                                            const firstGreeting = getFirstItem(list, sonbpIfconst.ITYPE_GREETING_TXT);
                                            const firstComment = getFirstItem(list, sonbpIfconst.ITYPE_COMMENT_TXT);
                                            if (firstGreeting !== undefined) {
                                                selectItem = firstGreeting;
                                            }
                                            else if (firstComment !== undefined) {
                                                selectItem = firstComment;
                                            }
                                        }

                                    }

                                    if (!that.usePcDesign) {
                                        // SPの場合、常に 画像読込・配置モードから開始
                                        that.editMode = edconst.EDIT_MODE_KIND.SET_PHOTO;
                                        selectItem = null;
                                    }

                                    Logger.debug("sonbp start #7 処理モード設定[" + that.editMode + "]");

                                    // 処理モード設定
                                    that.sonbpIf.setMode(that.editMode, function (res: any) {
                                        // 結果判定
                                        if (res.code === 0) {
                                            Logger.debug("sonbp start 初期選択アイテム指定 [" + JSON.stringify(selectItem) + "]");

                                            // 初期選択アイテム指定
                                            if (selectItem !== null) {
                                                that.sonbpIf.selectItem(selectItem.item_type, selectItem.idx,
                                                    function (res: any) {
                                                        if (res.code === 0) {
                                                            Logger.debug("sonbp start 初期選択アイテム指定 OK");
                                                        }
                                                        else {
                                                            Logger.error("sonbp start 初期選択アイテム指定 NG [" + res.msg + "]");
                                                        }
                                                    });
                                            }

                                            // 編集開始OK
                                            result = true;
                                            resolve(true);
                                        }
                                        else {
                                            that.errFunc(res);
                                            reject(-1);
                                        }
                                    });
                                }
                                else {
                                    that.errFunc(res);
                                    reject(-2);
                                }
                            });
                        }
                        else {
                            that.errFunc(res);
                            reject(-3);
                        }
                    });
                }
                else {
                    that.errFunc(res);
                    dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(6)', function () {
                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();
                    });
                    reject(-4);
                }
            });


            function getFirstItem(list: itemVenderProperty[], itemtype: string): itemVenderProperty {

                let selItem = util.relic.listFind(list, (vp: itemVenderProperty) => {
                    return vp.item_type === itemtype;
                });
                return selItem;
            }

        });
    }

    /**
     * 選択アイテム更新イベント(あいさつ文)
     * @param selectItem    ：選択アイテム
     */
    public onChangeGreetingSelectItem(selectItem: itemVenderProperty) {

        if (util.verify.isNotEmpty(selectItem)) {
            // 選択アイテムあり
            const selGreeting: edentity.greetingTranEntityEx = util.relic.listFind(this.greetingList, (g: edentity.greetingTranEntityEx) => {
                return g.id === selectItem.idx;
            });
            if (selGreeting !== undefined) {
                // パネルに入力情報の復元
                this.vue.$data.GreetingInfo.FontSize = selGreeting.size;
                this.vue.$data.GreetingInfo.Font = selGreeting.fontMaster.name;
                this.vue.$data.GreetingInfo.FontSample = selGreeting.fontMaster.url;
                this.vue.$data.GreetingInfo.CharLayout = selGreeting.charLayout;
                if (this.vue.$data.GreetingInfo.CharLayout == edconst.EditConst.CHAR_LAYOUT_Y) {
                    this.vue.$data.GreetingInfo.AlignY = selGreeting.alignDispVal;
                    this.vue.$data.GreetingInfo.ShowAlignY = true;
                }
                else {
                    this.vue.$data.GreetingInfo.AlignT = selGreeting.alignDispVal;
                    this.vue.$data.GreetingInfo.ShowAlignY = false;
                }
                this.vue.$data.GreetingInfo.OutlineFont = selGreeting.outlineChar;
                this.vue.$data.GreetingText = selGreeting.text;
                this.vue.$data.SelectCharColor = selGreeting.fontColorMaster.id;
                if (selGreeting.outlineChar) {
                    this.vue.$data.SelectOutlineCharColor = selGreeting.outlineFontColorMaster.id;
                }
                else {
                    this.vue.$data.SelectOutlineCharColor = this.colorMasterList[0].id;
                }
                this.vue.$data.GreetingInfo.Text = selGreeting.text;
            }
        }
        //    else {
        //        // 選択アイテムなし
        //        // パネルの入力情報を初期化
        //        this.vue.$data.GreetingInfo.FontSize = edconst.EditConst.FONT_SIZE_DEFAULT_T;
        //        this.vue.$data.GreetingInfo.Font = "";
        //        this.vue.$data.GreetingInfo.CharLayout = edentity.editUtil.directionToCharlayout(this.greetingDesign.direction);
        //        this.vue.$data.GreetingInfo.AlignY = edentity.editUtil.alignToAlignDispVal(this.vue.$data.GreetingInfo.CharLayout, this.greetingDesign.align);
        //        this.vue.$data.GreetingInfo.AlignT = edentity.editUtil.alignToAlignDispVal(this.vue.$data.GreetingInfo.CharLayout, this.greetingDesign.align);
        //        this.vue.$data.GreetingInfo.OutlineFont = false;
        //        this.vue.$data.GreetingInfo.Text = "";
        //        this.vue.$data.SelectCharColor = this.defaultFontColor.id;
        //        this.vue.$data.SelectOutlineCharColor = this.colorMasterList[0].id;
        //    }
    }

    private errFunc(result: any) {
        Logger.error(JSON.stringify(result));
    }

    /**
     * 処理モードの設定
     * @param mode      ：処理モード
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public setMode(mode: edconst.editModeKind, callbackOk: () => void, callbackNg: () => void): void {

        this.sonbpIf.setMode(mode, (res: any) => {
            if (res.code === 0) {
                // 設定OK
                this.editMode = mode;
                callbackOk();
            }
            else {
                // 設定NG
                callbackNg();
            }
        });

    }

    /**
     * 画像用 file_keyの生成
     * @param fileId    ：画像ID
     * @param toCorrect ：I2補正版？
     * @description     ：例）PHOTO@YYYYMMDD/テンポラリID@アップロード画像ID@off
     */
    public createPhotoFileKey(fileId: string, toCorrect: boolean): string {
        let fileIdSplit = fileId.split('@');
        let bright = fileIdSplit.length < 2 ? 0 : fileIdSplit[1];
        const fileKey: string = "PHOTO" + "@" + this.encCreateDate + "@" + this.tempId + "@" + fileIdSplit[0] + "@";
        let correctVal: string = toCorrect ? "on" : "off";

        if (correctVal == "on") {
            correctVal = correctVal + "@" + bright;
        }

        return fileKey + correctVal
    }

    /**
     * Canvasサイズ調整
     */
    public resizeContents(pageAreaSize?: number): void {

        this.sonbpIf.resizeContents(pageAreaSize);
    }

    /**
     * 写真枠に画像を配置（カレント枠）
     * @param target            ：対象画像情報
     * @param toCorrect         ：I2補正版？
     * @param fromCorrectEvent  ：画像補正する／しないイベントからの呼び出し？
     * @param callbackOk        ：OK時処理
     * @param callbackNg        ：NG時処理
     */
    public setPhoto(fileId: string, width: number, height: number, toCorrect: boolean, fromCorrectEvent: boolean, callbackOk: () => void, callbackNg: () => void) {

        const imgSize: any = { w: width, h: height };
        let fileKey = this.createPhotoFileKey(fileId, toCorrect);

        // sonbpへ依頼
        this.sonbpIf.setPhoto(fileKey, fileId, imgSize, fromCorrectEvent, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 画像削除(画像ID指定)
     * @param fileId    ：画像ID
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public removePhotoById(fileIds: string[], callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removePhotoById(fileIds, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * Myステッカー削除(画像ID指定)
     * @param fileId    ：画像ID
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public removeMyStampById(fileIds: string[], callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removeStampById(sonbpIfconst.ITYPE_MYSTAMP_IMG, fileIds, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 手書きスタンプ画像削除(画像ID指定)
     * @param fileId    ：画像ID
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public removeTegakiStampById(fileIds: string[], callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removeStampById(sonbpIfconst.ITYPE_FONTGENIC_IMG, fileIds, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }


    /**
     * 画像削除(カレント枠)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public removePhotoByCurrent(callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removePhoto((res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 画像アイテム一覧の取得
     */
    public getPhotoList(callbackOk: (list: itemVenderProperty[]) => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.getPhotoList(function (res: any, list: itemVenderProperty[]) {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

    }

    /**
     * アイテム選択指示
     * @param itemType  ：アイテム区分
     * @param idx       ：アイテム番号
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public selectItem(itemType: string, idx: string, callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ
        this.sonbpIf.selectItem(itemType, idx, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 指定アイテム種別のアイテム取得
     * @param itemType  ：アイテム種別
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public getItems(itemType: string[], callbackOk: (list: itemVenderProperty[]) => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.getItems(itemType, function (res: any, list: itemVenderProperty[]) {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 選択アイテムの取得
     */
    public getSelectItem(): itemVenderProperty {
        // sonbpへ依頼
        return this.sonbpIf.getSelectItem();
    }

    /**
     * 選択アイテムの枠ぴったり区分更新
     */
    public setPhotoWakuPita(doPita: boolean, callbackOk: () => void, callbackNg: () => void): void {

        // sonbpへ依頼
        this.sonbpIf.setPhotoWakuPita(doPita, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 指定アイテム種別の先頭アイテム選択状態に設定
     * @param itemType  ：アイテム種別
     * @param callbackOk：OK時処理
     * @param callbackOk：OK時処理(未選択)
     * @param callbackNg：NG時処理
     */
    public setSelectFirstItem(itemType: string, callbackOk: (selectItem: itemVenderProperty) => void, callUnSel: () => void, callbackNg: () => void) {

        const getItmType: string[] = [itemType];
        const that = this;

        // sonbpへ依頼
        this.sonbpIf.getItems(getItmType, function (res: any, list: itemVenderProperty[]) {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                if (list.length !== 0) {
                    // 先頭のアイテムを選択指定
                    that.sonbpIf.selectItem(list[0].item_type, list[0].idx, (res: any) => {
                        // 結果判定
                        if (res.code === 0) {
                            // 正常終了の場合
                            callbackOk(list[0]);
                        }
                        else {
                            // 異常終了の場合
                            Logger.error(res.msg);
                            callbackNg();
                        }
                    });
                }
                else {
                    callUnSel();
                }
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);

            }
        });
    }

    /**
     * アイテムの回転
     * @param deg       ：回転角度
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public rotateItem(deg: number, callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.rotateItem(deg, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

    }

    /**
     * アイテムの拡大／縮小
     * @param deg       ：拡縮率(1.0=100%)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public scaleItem(scale: number, callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.scaleItem(scale, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

    }

    /**
     * アイテムの移動
     * @param x         ：横移動量
     * @param y         ：縦移動量
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public moveItem(x: number, y: number, callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.moveItem(x, y, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * アイテムの移動(上)
     * @param y         ：移動量(絶対値)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public moveUpItem(y: number = this.MOVE_ITEM_AMOUNT_DEFAULT, callbackOk: () => void, callbackNg: () => void) {
        this.moveItem(0, y, callbackOk, callbackNg);
    }

    /**
     * アイテムの移動(下)
     * @param y         ：移動量(絶対値)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public moveDownItem(y: number = this.MOVE_ITEM_AMOUNT_DEFAULT, callbackOk: () => void, callbackNg: () => void) {
        this.moveItem(0, y * -1, callbackOk, callbackNg);
    }

    /**
     * アイテムの移動(右)
     * @param x         ：移動量(絶対値)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public moveRightItem(x: number = this.MOVE_ITEM_AMOUNT_DEFAULT, callbackOk: () => void, callbackNg: () => void) {
        this.moveItem(x, 0, callbackOk, callbackNg);
    }

    /**
     * アイテムの移動(左)
     * @param x         ：移動量(絶対値)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public moveLeftItem(x: number = this.MOVE_ITEM_AMOUNT_DEFAULT, callbackOk: () => void, callbackNg: () => void) {
        this.moveItem(x * -1, 0, callbackOk, callbackNg);
    }

    /**
     * アイテムの選択解除
     */
    public selectItemClear() {

        // sonbpへ依頼
        this.sonbpIf.selectItemClear();
    }

    /**
     * テキスト配置
     * @param itemType      ：アイテム区分
     * @param idx           ：アイテム番号
     * @param isSetModeNew  ：配置方法
     * @param reqParam      ：組版実行時の共通パラメータ
     * @param def_posi      ：サイズ・位置情報
     * @param json          ：組版結果JSON
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public setText(itemType: string, idx: string, isSetModeNew: boolean, reqParam: edentity.kumihanRequestParam, def_posi: { x: number, y: number, w: number, h: number, gen: number }, json: string, callbackOk: () => void, callbackNg: () => void) {

        const setMode: string = isSetModeNew ? this.GREETING_SET_MODE_NEW : this.GREETING_SET_MODE_UPD;
        const muki: string = (reqParam.hv === edconst.KUMIHAN_HV.VERTICAL) ? "0" : "1";

        Logger.debug("setText itemType[" + itemType + "] idx[" + idx + "] setMode[" + setMode + "] muki[" + muki + "]");

        if (def_posi) {
            Logger.debug("setText def_posi 変換前[" + JSON.stringify(def_posi) + "]");
            if (def_posi.w) {
                def_posi.w = sonbp.util.c2d.chgNum(def_posi.w, sonbp.constant.unit.MM, sonbp.constant.unit.PT);
            }
            if (def_posi.h) {
                def_posi.h = sonbp.util.c2d.chgNum(def_posi.h, sonbp.constant.unit.MM, sonbp.constant.unit.PT);
            }
            if (def_posi.x) {
                def_posi.x = sonbp.util.c2d.chgNum(def_posi.x, sonbp.constant.unit.MM, sonbp.constant.unit.PT);
            }
            if (def_posi.y) {
                def_posi.y = sonbp.util.c2d.chgNum(def_posi.y, sonbp.constant.unit.MM, sonbp.constant.unit.PT);
            }
            Logger.debug("setText def_posi 変換後[" + JSON.stringify(def_posi) + "]");
        }

        // sonbpへ依頼
        this.sonbpIf.setText(itemType, idx, json, def_posi, muki, function (res: any) {

            Logger.debug("sonbpIf.setText", res);

            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * テキスト削除(対象：選択テキストアイテム)
     */
    public removeText(callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removeText(function (res: any) {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * テキストアイテムの取得
     * @param itemType  ：アイテム区分
     */
    public getTextList(itemType: string, callbackOk: (list: itemVenderProperty[]) => void, callbackNg: () => void) {

        let result: itemVenderProperty[] = [];

        // sonbpへ依頼
        this.sonbpIf.getTextList(function (res: any, list: itemVenderProperty[]) {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                let targetList: itemVenderProperty[] = [];
                for (let i: number = 0; i < list.length; i++) {
                    if (list[i].item_type === itemType) {
                        targetList.push(list[i]);
                    }
                }
                callbackOk(targetList);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

        return result;
    }

    /**
     * あいさつ文テキストアイテムの取得
     */
    public getGreetingTextList(callbackNext: (list: itemVenderProperty[]) => void) {

        this.getTextList(sonbpIfconst.ITYPE_GREETING_TXT, callbackNext, () => { });

    }

    /**
     * 差出人文テキストアイテムの取得
     */
    public getSenderTextList(callbackNext: (list: itemVenderProperty[]) => void) {

        this.getTextList(sonbpIfconst.ITYPE_SENDER_TXT, callbackNext, () => { });

    }

    /**
     * あいさつ文テキスト配置
     * @param idx           ：アイテム番号
     * @param isSetModeNew  ：配置方法
     * @param reqParam      ：組版実行時の共通パラメータ
     * @param json          ：組版結果JSON
     * @param hasNoDesignMst：デザインマスタを持つか？
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public setGreetingText(idx: string, isSetModeNew: boolean, reqParam: edentity.kumihanRequestParam, json: string, hasNoDesignMst: boolean, callbackOk: () => void, callbackNg: () => void) {

        Logger.debug("setGreetingText idx[" + idx + "] isSetModeNew[" + isSetModeNew + "]");

        // 1件目は位置指定あり、それ以外はsonbpにおまかせ
        // ※1件目でもデザインマスタの設定がなければsonbpに任せる(中心中央)
        let useDefpos: boolean = false;
        if (this.greetingList.length === 0) {
            useDefpos = true;
        }
        else if (this.greetingList[0].id === idx) {
            // 1件目の更新の場合も設定する
            useDefpos = true;
        }

        let def_posi: any = null;
        if (useDefpos) {
            if (!hasNoDesignMst && (0 < reqParam.width && 0 < reqParam.height)) {
                // デザインマスタに従う
                let x: number = null;
                let y: number = null;
                if (util.verify.isNotEmpty(this.greetingDesign)) {
                    x = this.greetingDesign.x;
                    y = this.greetingDesign.y;
                }
                // x,y -> mm ,w,h -> mm
                def_posi = { x: x, y: y, w: reqParam.width, h: reqParam.height, gen: reqParam.pivot };
            }
        }

        if (def_posi === null) {
            // 幅・高さは常に上位から設定されてくる前提
            def_posi = { x: null, y: null, w: reqParam.width, h: reqParam.height, gen: reqParam.pivot };
        }


        this.setText(sonbpIfconst.ITYPE_GREETING_TXT, idx, isSetModeNew, reqParam, def_posi, json, callbackOk, callbackNg);
    }

    /** 差出人テキスト配置
     * @param isSetModeNew  ：配置方法
     * @param setOrder      ：差出人パネル入力値
     * @param reqParam      ：組版実行時の共通パラメータ
     * @param json          ：組版結果JSON
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public setSenderText(isSetModeNew: boolean, setOrder: edentity.senderTranEntityEx, reqParam: edentity.kumihanRequestParam, json: string, callbackOk: () => void, callbackNg: () => void) {

        Logger.debug("setSenderText isSetModeNew[" + isSetModeNew + "]");

        let gen: number;
        if (setOrder.sender.type === edconst.EditConst.SENDER_TYPE_FREE) {
            // 自由入力の場合
            gen = reqParam.pivot;
        }
        else {
            // 上記以外の場合(通常入力(個人／法人))
            if (setOrder.charLayout === edconst.EditConst.CHAR_LAYOUT_Y) {
                // 横書き
                gen = 7;
            }
            else if (setOrder.charLayout === edconst.EditConst.CHAR_LAYOUT_CY) {
                // センター横
                gen = 8;
            }
            else {
                // 上記以外(縦書き)
                gen = 9;
            }
        }

        let def_posi: any = null;
        if (reqParam.width && reqParam.height) {
            if (0 < reqParam.width && 0 < reqParam.height) {
                let x: number = null;
                let y: number = null;
                if (util.verify.isNotEmpty(this.senderDesign)) {
                    x = this.senderDesign.x;
                    y = this.senderDesign.y;
                }
                // x,y -> mm ,w,h -> mm
                def_posi = { x: x, y: y, w: reqParam.width, h: reqParam.height, gen: gen };
            }
        }

        this.setText(sonbpIfconst.ITYPE_SENDER_TXT, "0", isSetModeNew, reqParam, def_posi, json, callbackOk, callbackNg);
    }

    /**
     * DB/iDBの情報から、あいさつ文情報一覧を復元
     * @param restoreFromIdb    ：iDBから復元するかフラグ
     * @param idbGreetingList   ：iDBのあいさつ文情報
     * @param greetingList      ：編集情報取得のあいさつ文情報
     * @param fontMaster        ：フォントマスタの一覧
     * @param colorMaster       ：色マスタの一覧
     */
    public restoreGreetingList(restoreFromIdb: boolean, idbGreetingList: idbEdit.greetingInfo[], greetingList: GetEditInfo.GetEditInfoGreetingTranEntity[], fontMaster: GetEditInfo.GetEditInfoFontEntity[], colorMaster: GetEditInfo.GetEditInfoColorEntity[]): void {

        this.greetingList = [];

        if (restoreFromIdb && idbGreetingList) {
            Logger.debug("あいさつ文情報一覧 indexDBからの復元");

            // idbの情報から復元
            for (let i: number = 0; i < idbGreetingList.length; i++) {

                let newItem: edentity.greetingTranEntityEx = new edentity.greetingTranEntityEx();
                // インデックス
                newItem.id = idbGreetingList[i].id + "";
                // 文章番号
                newItem.greetingNo = idbGreetingList[i].greetingNo;
                // フォント名
                newItem.font = idbGreetingList[i].fontId;
                // フォントサイズ
                newItem.size = idbGreetingList[i].size;
                // color(CMYK)
                newItem.color = idbGreetingList[i].colorId;
                // フチ文字のcolor(CMYK)
                newItem.outlineColor = idbGreetingList[i].outlineColor;
                // 行揃え
                newItem.align = idbGreetingList[i].align;
                // あいさつ文テキスト
                newItem.text = idbGreetingList[i].text;
                // 組方向
                newItem.direction = idbGreetingList[i].direction;

                // フチ文字にする
                newItem.outlineChar = util.verify.isNotEmpty(newItem.outlineColor) ? true : false;

                // フォントマスタ
                newItem.fontMaster = util.relic.listFind(fontMaster, (f: GetEditInfo.GetEditInfoFontEntity) => {
                    return f.id === newItem.font;
                });
                // 文字色マスタ
                newItem.fontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
                    return c.id === newItem.color;
                });
                if (newItem.outlineChar) {
                    // フチ文字色トマスタ
                    newItem.outlineFontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
                        return c.id === newItem.outlineColor;
                    });
                }
                // 文字レイアウト
                newItem.charLayout = edtool.editUtil.directionToCharlayout(newItem.direction);
                // 行揃え
                newItem.alignDispVal = edtool.editUtil.alignToAlignDispVal(newItem.charLayout, newItem.align);

                this.greetingList.push(newItem);
            }

        }
        else if (!restoreFromIdb && greetingList) {
            Logger.debug("あいさつ文情報一覧 DBからの復元");

            // dbの情報から復元
            for (let i: number = 0; i < greetingList.length; i++) {

                let newItem: edentity.greetingTranEntityEx = new edentity.greetingTranEntityEx();
                // インデックス
                newItem.id = greetingList[i].id + "";
                // 文章番号
                newItem.greetingNo = greetingList[i].greetingNo;
                // フォント名
                newItem.font = greetingList[i].font;
                // フォントサイズ
                newItem.size = greetingList[i].size;
                // color(CMYK)
                newItem.color = greetingList[i].color;
                // フチ文字のcolor(CMYK)
                newItem.outlineColor = greetingList[i].outlineColor;
                // 行揃え
                newItem.align = greetingList[i].align;
                // あいさつ文テキスト
                newItem.text = greetingList[i].text;
                // 組方向
                newItem.direction = greetingList[i].direction;

                // フチ文字にする
                newItem.outlineChar = util.verify.isNotEmpty(newItem.outlineColor) ? true : false;

                // フォントマスタ
                newItem.fontMaster = util.relic.listFind(fontMaster, (f: GetEditInfo.GetEditInfoFontEntity) => {
                    return f.id === newItem.font;
                });
                // 文字色マスタ
                newItem.fontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
                    return c.id === newItem.color;
                });
                if (newItem.outlineChar) {
                    // フチ文字色トマスタ
                    newItem.outlineFontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
                        return c.id === newItem.outlineColor;
                    });
                }
                // 文字レイアウト
                newItem.charLayout = edtool.editUtil.directionToCharlayout(newItem.direction);
                // 行揃え
                newItem.alignDispVal = edtool.editUtil.alignToAlignDispVal(newItem.charLayout, newItem.align);

                this.greetingList.push(newItem);
            }
        }
    }

    /**
     * 差出人情報の復元
     * @param senderDb      ：差出人情報
     * @param fontMaster    ：フォントマスタ
     * @param colorMaster   ：カラーマスタ
     */
    public restoreSenderInfo(senderDb: GetEditInfo.GetEditInfoSenderEntity, fontMaster: GetEditInfo.GetEditInfoFontEntity[], colorMaster: GetEditInfo.GetEditInfoColorEntity[]) {

        this.senderInfo = new edentity.senderTranEntityEx();

        //this.senderInfo.sender = { ...senderDb };
        this.senderInfo.sender = JSON.parse(JSON.stringify(senderDb));

        // フチ文字にする
        this.senderInfo.outlineChar = util.verify.isNotEmpty(this.senderInfo.sender.outlineColor) ? true : false;

        // フォントマスタ
        this.senderInfo.fontMaster = util.relic.listFind(fontMaster, (f: GetEditInfo.GetEditInfoFontEntity) => {
            return f.id === this.senderInfo.sender.font;
        });
        if (!this.senderInfo.fontMaster) {
            this.senderInfo.fontMaster = fontMaster[0];
        }

        // 文字色マスタ
        this.senderInfo.fontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
            return c.id === this.senderInfo.sender.color;
        });
        if (!this.senderInfo.fontColorMaster) {
            this.senderInfo.fontColorMaster = colorMaster[0];
        }

        if (this.senderInfo.outlineChar) {
            // フチ文字色トマスタ
            this.senderInfo.outlineFontColorMaster = util.relic.listFind(colorMaster, (c: GetEditInfo.GetEditInfoColorEntity) => {
                return c.id === this.senderInfo.sender.outlineColor;
            });
            if (!this.senderInfo.outlineFontColorMaster) {
                this.senderInfo.outlineFontColorMaster = colorMaster[0];
            }
        }

        // 文字レイアウト
        this.senderInfo.charLayout = edtool.editUtil.directionToCharlayout(this.senderInfo.sender.direction);

        // 行揃え
        this.senderInfo.alignDispVal = edtool.editUtil.alignToAlignDispVal(this.senderInfo.charLayout, this.senderInfo.sender.align);

        if (util.verify.isNotEmpty(this.senderInfo.sender)) {
            if (util.verify.isNotEmpty(this.senderInfo.sender.senderInfo.addresses)) {
                if (0 < this.senderInfo.sender.senderInfo.addresses.length) {
                    // 電話番号1
                    this.senderInfo.Tel1DispVal = edtool.editUtil.telTypeToTelDispVal(this.senderInfo.sender.senderInfo.addresses[0].telType1);
                    // 電話番号2
                    this.senderInfo.Tel2DispVal = edtool.editUtil.telTypeToTelDispVal(this.senderInfo.sender.senderInfo.addresses[0].telType2);
                }
            }
        }
    }

    /**
     * 銀塩／印刷 仕上がりの変更
     * @param area_type  ：仕上がり区分(1=印刷(白フチ)、2=銀塩(赤線))
     */
    public setAreaView(area_type: string): void {

        // sonbpへ依頼
        this.sonbpIf.setAreaView(area_type);

    }

    /**
     * PDF保存
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public save(callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.save((res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

    }

    /**
     * 差出人情報パネルの復元
     * @param that  ：this
     * @param target：差出人情報
     */
    public setSenderOrder(that: any, target: edentity.senderTranEntityEx) {

        // 入力値設定

        // フォント
        that.vue.$data.SenderInfo.Setting.Font = target.fontMaster.name;

        // 文字色
        that.vue.$data.SelectCharColor = target.fontColorMaster.id;

        // フチ文字
        that.vue.$data.SenderInfo.Setting.OutlineFont = target.sender.outlineColor ? true : false;

        // フチ文字色
        if (that.vue.$data.SenderInfo.Setting.OutlineFont) {
            that.vue.$data.SelectOutlineCharColor = target.outlineFontColorMaster.id;
        }
        else {
            that.vue.$data.SelectOutlineCharColor = that.colorMasterList[0].id;
        }

        // 個人入力？
        if (target.sender.type === edconst.EditConst.SENDER_TYPE_FREE) {
            that.vue.$data.SenderInfo.NormalInput.PersonalUse = true;
        }
        else {
            that.vue.$data.SenderInfo.NormalInput.PersonalUse = (target.sender.type === edconst.EditConst.SENDER_TYPE_PORSONAL) ? true : false;
        }

        // 文字レイアウト
        that.vue.$data.SenderInfo.Setting.CharLayoutEx = that.getCharLayout(target.sender.senderInfo.isHojin, target.sender.layout, false);
        that.vue.$data.SenderInfo.Setting.CharLayout = edtool.editUtil.directionToCharlayout(target.sender.direction);

        // 文字サイズ
        const fontSizeDefault: number = (that.vue.$data.SenderInfo.Setting.CharLayout === edconst.EditConst.CHAR_LAYOUT_T) ? edconst.EditConst.FONT_SIZE_DEFAULT_T : edconst.EditConst.FONT_SIZE_DEFAULT_Y;
        that.vue.$data.SenderInfo.Setting.FontSize = target.sender.size === 0 ? fontSizeDefault : target.sender.size;

        // 行揃え(組方向)
        if (target.charLayout === edconst.EditConst.CHAR_LAYOUT_Y) {
            that.vue.$data.SenderInfo.Setting.AlignY = target.alignDispVal;
            that.vue.$data.SenderInfo.ShowSenderAlignY = true;
        }
        else if (target.charLayout === edconst.EditConst.CHAR_LAYOUT_CY) {
            that.vue.$data.SenderInfo.Setting.AlignY = target.alignDispVal;
            that.vue.$data.SenderInfo.ShowSenderAlignY = true;
        }
        else {
            that.vue.$data.SenderInfo.Setting.AlignT = target.alignDispVal;
            that.vue.$data.SenderInfo.ShowSenderAlignY = false;
        }

        // 入力方法別に入力値を取得
        if (target.sender.type === edconst.EditConst.SENDER_TYPE_FREE) {
            // 自由入力
            // 文章
            that.vue.$data.SenderInfo.FreeInput = target.sender.senderInfo.free;
            that.vue.$data.SenderInfo.IsNormalInput = false;
        }
        else {
            that.vue.$data.SenderInfo.IsNormalInput = true;

            // 住所
            if (target.sender.senderInfo.addresses && 0 < target.sender.senderInfo.addresses.length) {
                // 郵便番号
                that.vue.$data.SenderInfo.NormalInput.ZipCode1 = target.sender.senderInfo.addresses[0].yubin1;
                that.vue.$data.SenderInfo.NormalInput.ZipCode2 = target.sender.senderInfo.addresses[0].yubin2;

                // 住所
                that.vue.$data.SenderInfo.NormalInput.Address1 = target.sender.senderInfo.addresses[0].jusho1;
                that.vue.$data.SenderInfo.NormalInput.Address2 = target.sender.senderInfo.addresses[0].jusho2;
                that.vue.$data.SenderInfo.NormalInput.Address3 = target.sender.senderInfo.addresses[0].jusho3;

                // 電話番号1
                that.vue.$data.SenderInfo.NormalInput.Contact[0].Type = target.Tel1DispVal;
                that.vue.$data.SenderInfo.NormalInput.Contact[0].Tel1 = target.sender.senderInfo.addresses[0].telNo1_1;
                that.vue.$data.SenderInfo.NormalInput.Contact[0].Tel2 = target.sender.senderInfo.addresses[0].telNo1_2;
                that.vue.$data.SenderInfo.NormalInput.Contact[0].Tel3 = target.sender.senderInfo.addresses[0].telNo1_3;

                // 電話番号2
                that.vue.$data.SenderInfo.NormalInput.Contact[1].Type = target.Tel2DispVal;
                that.vue.$data.SenderInfo.NormalInput.Contact[1].Tel1 = target.sender.senderInfo.addresses[0].telNo2_1;
                that.vue.$data.SenderInfo.NormalInput.Contact[1].Tel2 = target.sender.senderInfo.addresses[0].telNo2_2;
                that.vue.$data.SenderInfo.NormalInput.Contact[1].Tel3 = target.sender.senderInfo.addresses[0].telNo2_3;
            }

            // e-mal
            if (target.sender.senderInfo.emails) {
                for (let i: number = 0; i < target.sender.senderInfo.emails.length; i++) {
                    if (i === 0) {
                        // e-mal 1
                        that.vue.$data.SenderInfo.NormalInput.Email.Mail1 = target.sender.senderInfo.emails[i].address;
                    }
                    else if (i === 1) {
                        // e-mal 2
                        that.vue.$data.SenderInfo.NormalInput.Email.Mail2 = target.sender.senderInfo.emails[i].address;
                    }
                }
            }

            // 名前
            if (target.sender.senderInfo.names) {
                for (let i: number = 0; i < target.sender.senderInfo.names.length; i++) {
                    that.vue.$data.SenderInfo.NormalInput.Names[i].LastName = target.sender.senderInfo.names[i].lastName;
                    that.vue.$data.SenderInfo.NormalInput.Names[i].LastNameKana = target.sender.senderInfo.names[i].lastRubi;
                    that.vue.$data.SenderInfo.NormalInput.Names[i].FirstName = target.sender.senderInfo.names[i].firstName;
                    that.vue.$data.SenderInfo.NormalInput.Names[i].FirstNameKana = target.sender.senderInfo.names[i].firstRubi;
                    that.vue.$data.SenderInfo.NormalInput.Names[i].PS = target.sender.senderInfo.names[i].ps;
                }
            }

            if (target.sender.type === edconst.EditConst.SENDER_TYPE_CORP && target.sender.senderInfo.corps && 0 < target.sender.senderInfo.corps.length) {
                // 法人
                // 会社名
                that.vue.$data.SenderInfo.NormalInput.Company.Name = target.sender.senderInfo.corps[0].name;
                // 部署名
                that.vue.$data.SenderInfo.NormalInput.Company.Department = target.sender.senderInfo.corps[0].busyo;
                // 肩書
                that.vue.$data.SenderInfo.NormalInput.Company.Position = target.sender.senderInfo.names[0].title;
            }
        }


        if (!that.usePcDesign) {
            // SP用
            if (target.sender.type === edconst.EditConst.SENDER_TYPE_FREE) {
                that.vue.$data.SenderInfo.Setting.Format = edconst.EditConst.SENDER_TYPE_FREE_STR;
            }
            else if (target.sender.type === edconst.EditConst.SENDER_TYPE_CORP) {
                that.vue.$data.SenderInfo.Setting.Format = edconst.EditConst.SENDER_TYPE_CORP_STR;
            }
            else {
                that.vue.$data.SenderInfo.Setting.Format = edconst.EditConst.SENDER_TYPE_PORSONAL_STR;
            }
        }
    }

    /**
     * パラメータ値を条件に文字レイアウトコンボ選択値を取得
     * @param isHojin   ：個人／法人フラグ
     * @param layoutCd  ：レイアウトコード
     * @param isFree    ：自由入力フラグ
     */
    public getCharLayout(isHojin: boolean, layoutCd: string, isFree: boolean): string {

        let charLayout: string;

        // レイアウト記号
        if (isHojin) {
            // 法人の場合
            if (layoutCd === edconst.EditConst.LAYOUTCD_HOJIN_T) {
                // 縦
                charLayout = edconst.EditConst.CHAR_LAYOUT_T;
            }
            else if (layoutCd === edconst.EditConst.LAYOUTCD_HOJIN_CY) {
                // センター横
                charLayout = isFree ? edconst.EditConst.CHAR_LAYOUT_Y : edconst.EditConst.CHAR_LAYOUT_CY;
            }
            else {
                // 上記以外(横)
                charLayout = edconst.EditConst.CHAR_LAYOUT_Y;
            }
        }
        else {
            // 個人の場合
            if (layoutCd === edconst.EditConst.LAYOUTCD_PERSONAL_T) {
                // 縦
                charLayout = edconst.EditConst.CHAR_LAYOUT_T;
            }
            else if (layoutCd === edconst.EditConst.LAYOUTCD_PERSONAL_CY) {
                // センター横
                charLayout = isFree ? edconst.EditConst.CHAR_LAYOUT_Y : edconst.EditConst.CHAR_LAYOUT_CY;
            }
            else {
                // 上記以外(横)
                charLayout = edconst.EditConst.CHAR_LAYOUT_Y;
            }
        }

        return charLayout;
    }

    /**
     * スタンプ用 file_keyの生成
     * @param fileName  ：ファイル名(拡張子あり＋暗号化)
     * @description     ：例）STAMP@ファイル名
     */
    public createStampFileKey(fileName: string): string {

        return "STAMP" + "@" + fileName;
    }

    /**
     * Myスタンプ用 file_keyの生成
     * @param fileName  ：ファイル名(拡張子あり＋暗号化)
     * @description     ：例）STAMP@ファイル名
     */
    public createMyStampFileKey(fileId: string): string {
        return "MYSTAMP" + "@" + this.encCreateDate + "@" + this.tempId + "@" + fileId;
    }

    /**
     * スタンプを配置
     * @param idx          ：アイテム番号
     * @param fileName     ：ファイル名(暗号化)
     * @param callbackOk   ：OK時処理
     * @param callbackNg   ：NG時処理
     */
    public setStamp(idx: number, stampMaster: GetEditInfo.GetEditInfoStampCategoryEntity, callbackOk: () => void, callbackNg: () => void) {

        const fileKey: string = this.createStampFileKey(stampMaster.name);
        const img_size = { w: stampMaster.width, h: stampMaster.height };

        Logger.debug("スタンプを配置 idx[" + idx + "] fileKey[" + fileKey + "] master[" + JSON.stringify(stampMaster) + "]");
        Logger.debug("スタンプを配置 width[" + img_size.w + "]pt height[" + img_size.h + "]pt");

        // sonbpへ依頼
        this.sonbpIf.setStamp(sonbpIfconst.ITYPE_STAMP_IMG, idx.toString(), fileKey, stampMaster.id, img_size, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * Myステッカーを配置
     * @param idx          ：アイテム番号
     * @param fileName     ：ファイル名(暗号化)
     * @param callbackOk   ：OK時処理
     * @param callbackNg   ：NG時処理
     */
    public setMyStamp(idx: number, stampMaster: edentity.uploadPhoto, callbackOk: () => void, callbackNg: () => void) {

        const fileKey: string = this.createMyStampFileKey(stampMaster.fileId);
        const img_size = { w: stampMaster.width, h: stampMaster.height };

        Logger.debug("Myステッカーを配置 idx[" + idx + "] fileKey[" + fileKey + "] master[" + JSON.stringify(stampMaster) + "]");
        Logger.debug("Myステッカーを配置 width[" + img_size.w + "]pt height[" + img_size.h + "]pt");

        // sonbpへ依頼
        this.sonbpIf.setStamp(sonbpIfconst.ITYPE_MYSTAMP_IMG, idx.toString(), fileKey, stampMaster.fileId, img_size, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * 手書きスタンプを配置
     * @param idx          ：アイテム番号
     * @param fileName     ：ファイル名(暗号化)
     * @param callbackOk   ：OK時処理
     * @param callbackNg   ：NG時処理
     */
    public setTegakiStamp(idx: number, fileIdWidthAtmark: string, width: number, height: number, callbackOk: () => void, callbackNg: () => void) {

        const fileKey: string = "FONTGENIC" + "@" + this.encCreateDate + "@" + this.tempId + "@" + fileIdWidthAtmark;
        const img_size = { w: width, h: height };

        Logger.debug("手書きスタンプを配置 idx[" + idx + "] fileKey[" + fileKey + "]");
        Logger.debug("手書きスタンプを配置 width[" + img_size.w + "]pt height[" + img_size.h + "]pt");

        // sonbpへ依頼
        this.sonbpIf.setStampByFontGenic(idx.toString(), fileKey, fileIdWidthAtmark, img_size, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * スタンプ削除(カレント)
     * @param callbackOk：OK時処理
     * @param callbackNg：NG時処理
     */
    public removeStampByCurrent(callbackOk: () => void, callbackNg: () => void) {

        // sonbpへ依頼
        this.sonbpIf.removeStamp((res: any) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

    /**
     * スタンプ（マスタ・マイ・手書き 全て）アイテムの取得
     */
    public getAllStampList(callbackOk: (vpList: itemVenderProperty[]) => void): void {

        this.sonbpIf.getStampList((res: any, list: itemVenderProperty[]) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
            }
        });

    }

    /**
     * スタンプ（マスタ）アイテムの取得
     */
    public getMstStampList(callbackOk: (vpList: itemVenderProperty[]) => void): void {

        this.sonbpIf.getItems([sonbpIfconst.ITYPE_STAMP_IMG], (res: any, list: itemVenderProperty[]) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
            }
        });

    }

    /**
     * マイステッカーアイテムの取得
     */
    public getMyStampList(callbackOk: (vpList: itemVenderProperty[]) => void): void {

        this.sonbpIf.getItems([sonbpIfconst.ITYPE_MYSTAMP_IMG], (res: any, list: itemVenderProperty[]) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
            }
        });
    }

    /**
     * 手書きスタンプアイテムの取得
     */
    public getTegakiStampList(callbackOk: (vpList: itemVenderProperty[]) => void): void {

        this.sonbpIf.getItems([sonbpIfconst.ITYPE_FONTGENIC_IMG], (res: any, list: itemVenderProperty[]) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk(list);
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
            }
        });
    }

    /**
     * ２つの画像を入れ替え
     * @param idxFrom       ；画像枠(From)のアイテム番号
     * @param idxTo         ：画像枠(To)のアイテム番号
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public mutualTradePhoto(idxA: string, idxB: string, callbackOk: () => void, callbackNg: () => void): void {

        this.sonbpIf.mutualTradePhoto(idxA, idxB, (res: any, list: itemVenderProperty[]) => {
            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });

    }

    /**
     * 操作履歴準備(transaction sart)
     */
    public historyStart(): boolean {

        Logger.debug("操作履歴準備(transaction sart)");

        return this.sonbpIf.historyStart();

    }

    /**
     * 操作確定(transaction commit)
     */
    public historyCommit(): boolean {

        Logger.debug("操作確定(transaction commit)");

        return this.sonbpIf.historyCommit();

    }

    /**
     * 操作取消(transaction rollback)
     * @param callbackOk    ：OK時処理
     * @param callbackNg    ：NG時処理
     */
    public historyAllUndo(callbackOk: () => void, callbackNg: () => void): void {

        this.sonbpIf.historyAllUndo((res: any) => {

            Logger.debug("操作取消(transaction rollback) [" + JSON.stringify(res) + "]");

            // 結果判定
            if (res.code === 0) {
                // 正常終了の場合
                callbackOk();
            }
            else {
                // 異常終了の場合
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }


    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

    /**
     * 画像一覧→画像のドラッグ開始イベント
     * @param event     ：ドラッグイベントオブジェクト
     * @param target    ：対象画像情報
     * @param callbackOk：ドロップOK処理
     * @param callbackNg：ドロップNG処理
     */
    public onDragStartPhoto(event: DragEvent, fileId: string, width: number, height: number, callbackOk: (vpList: itemVenderProperty[]) => void, callbackNg: () => void) {

        let imgElement: HTMLImageElement = new Image();
        imgElement.src = (event as any).currentTarget.src;

        const imgSize: any = { w: width, h: height };

        let toCorrect = this.designMaster.editMode != edconst.EditConst.DSN_MST_EDIT_MODE_LIMIT;
        let fileKey = this.createPhotoFileKey(fileId, toCorrect);

        Logger.debug("setPhotoDragger fileKey[" + fileKey + "] fileId[" + fileId + "] imgSize[" + JSON.stringify(imgSize) + "]");

        // sonbpへドラッグ情報を通知
        this.sonbpIf.setPhotoDragger(event, imgElement, fileKey, fileId, imgSize, (res: any) => {
            // 結果判定
            if (res.code === 0) {
                // ドロップOK

                // 画像リスト取得
                this.sonbpIf.getPhotoList((res: any, list: itemVenderProperty[]) => {
                    // 画像一覧の使用中画像の判定(アイコン表示制御)
                    callbackOk(list);
                });
            }
            else {
                // ドロップNG
                Logger.error(res.msg);
                callbackNg();
            }
        });
    }

}

/**
 *  sonbpアイテムのベンダープロパティ
 */
export class itemVenderProperty {
    /**
     * アイテム区分
     */
    public item_type: string;
    /**
     * アイテム番号
     */
    public idx: string;
    /**
     * 画像のファイルID
     */
    public file_id: string;
    /**
     * X座標
     */
    public x: number;
    /**
     * Y座標
     */
    public y: number;
    /**
     * 幅
     */
    public w: number;
    /**
     * 高さ
     */
    public h: number;
    /**
     * 回転角度
     */
    public r: number;
    /**
     * 枠ぴったり区分
     */
    public waku_pita: boolean;
}
